import React from 'react'
import { VBox, VBoxProps } from '~/ui/components'

export type Props = Omit<VBoxProps, 'align' | 'justify'>

export default React.forwardRef(function Center(props: Props, ref: React.Ref<HTMLDivElement>) {
  return <VBox {...props} align='center' justify='middle' ref={ref}/>
})